import React, { useEffect, useState } from "react";
import {
  Grid,
  Tooltip,
  Button,
  Typography,
  Box,
  Paper,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle/PageTitle";
import useStyles from "../../../themes/style.js";
import { IoMdDownload } from "react-icons/io";
import { CloudUpload } from "@material-ui/icons";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";
import { Document, Page, pdfjs } from "react-pdf";

const AdminPolicyHandbook = () => {
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const handleNotificationCall = useNotification();

  const token = localStorage.getItem("token");
  const [pdfFile, setPdfFile] = useState();
  const [pdfURL, setPdfURL] = useState();
  const [numPages, setNumPages] = useState();
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    const file = e.target.files[0];

    if (!file) {
      handleNotificationCall("error", "Upload Failed");
      return;
    }
    handleUpload(file);
    console.log(selectedFile, e.target.files[0]);
  };

  const handleUpload = async (file) => {
    if (!selectedFile) {
      setUploadStatus("Please select a file to upload.");
      return;
    }

    var fileName = file.name.split(".").pop();

    if (fileName !== "pdf") {
      handleNotificationCall("error", "Invalid File Format");
      return;
    }

    const formData = new FormData();
    formData.append("document", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/uploadPolicyHandBook


`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchData();
      }
    } catch (error) {
      setUploadStatus(
        `Upload failed: ${error.response?.data?.message || error.message}`,
      );
    }
  };

  const fetchData = async () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}employee/getPolicyHandBook`,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.status == "200") {
        const file = response.data;
        setPdfFile(file);

        const url = URL.createObjectURL(file);
        setPdfURL(url); // Store URL for use in the iframe

        console.log(typeof response.data);
      }
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Policy Handbook" />
        </Grid>
      </Grid>

      <Box display="flex" flexDirection="column" alignItems="center" p={2}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          mt={2}
        >
          {/* Drag and Drop Zone */}
          <Paper
            variant="outlined"
            style={{
              width: "45%",
              padding: "20px",
              border: "2px dashed #1976d2",
              textAlign: "center",
              marginRight: "10px",
            }}
          >
            <CloudUpload style={{ fontSize: "50px", color: "#1976d2" }} />

            <Typography variant="body2">Upload only PDF</Typography>

            <Button
              variant="contained"
              color="primary"
              component="label"
              style={{ marginTop: "10px" }}
            >
              Upload File
              <input
                type="file"
                hidden
                multiple
                accept=".pdf"
                onChange={handleFileChange}
              />
            </Button>
          </Paper>
          {uploadStatus && (
            <Typography variant="body2" color="secondary">
              {uploadStatus}
            </Typography>
          )}
        </Box>
      </Box>

      <Grid container direction="row" justifyContent="center" spacing={2}>
        <div className={` ${classes.inputRoot} `}>
          <div
            className={classes.inputRoot}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Typography variant="subtitle2">Policy Handbook</Typography>
            <Typography
              variant="subtitle2"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
              }}
            >
              <>
                <Tooltip
                  title="Dowmload"
                  placement="right"
                  aria-label="download"
                >
                  <a
                    style={{ fontSize: "1.3rem", color: "#29b229" }}
                    href={pdfURL}
                  >
                    <IoMdDownload />
                  </a>
                </Tooltip>
              </>
            </Typography>
          </div>
        </div>
        <div
          style={{
            boxShadow:
              "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
            marginBottom: "20px",
            maxHeight:"max-content",
            overflow:"auto"
          }}
        >
          <Document
            file={pdfFile}
            onLoadSuccess={onDocumentLoadSuccess}
            width="100%"
          >
            {Array.from(new Array(numPages), (el, index) => (
              <div key={`page_${index + 1}`} className="page">
                <Page pageNumber={index + 1} renderTextLayer={false} />
              </div>
            ))}
          </Document>
        </div>
      </Grid>
    </div>
  );
};

export default AdminPolicyHandbook;
